import { render, staticRenderFns } from "./Employees.vue?vue&type=template&id=2124c7fe&"
import script from "./Employees.vue?vue&type=script&lang=ts&"
export * from "./Employees.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports